"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var warning = require("warning");
var utils_1 = require("./utils");
var types_1 = require("./helpers/types");
var proxy_1 = require("./helpers/proxy");
var equal_1 = require("./helpers/equal");
var enum_1 = require("./helpers/enum");
var kya_1 = require("kya");
function noop() { return; }
var Formask = /** @class */ (function (_super) {
    __extends(Formask, _super);
    function Formask(props) {
        var _this = _super.call(this, props) || this;
        _this.getFormaskProps = function () {
            var _a = _this.state, values = _a.values, isSubmitting = _a.isSubmitting, touches = _a.touches, errors = _a.errors, isValid = _a.isValid, types = _a.types;
            var formaskProps = {
                errors: errors,
                values: values,
                touches: touches,
                types: types,
                isValid: isValid,
                isSubmitting: isSubmitting,
                setIsSubmitting: _this.setIsSubmitting,
                submitHandler: _this.submitHandler,
                changeHandler: _this.changeHandler,
                blurHandler: _this.blurHandler,
                reset: _this.reset,
                getFieldsValue: _this.getFieldsValue,
                hook: _this.hook,
                setTouches: _this.setTouches,
                validate: _this.validate,
            };
            return formaskProps;
        };
        _this.getFieldsValue = function () {
            return _this.state.values;
        };
        _this.hook = function (id, options) {
            if (options === void 0) { options = {}; }
            return function (Widget) {
                var _a, _b, _c, _d;
                var _e = options.changeHandlerName, changeHandlerName = _e === void 0 ? 'onChange' : _e, _f = options.blurHandlerName, blurHandlerName = _f === void 0 ? 'onBlur' : _f, _g = options.controlled, controlled = _g === void 0 ? true : _g;
                // we don't know what unknown is.
                // tslint:disable-next-line:no-any
                var hookChangeHandler = function (unknown) {
                    // calling props.onChange.
                    if (Widget.props[changeHandlerName] &&
                        typeof Widget.props[changeHandlerName] === 'function') {
                        if (typeof Widget.props[changeHandlerName] === 'function') {
                            Widget.props[changeHandlerName](unknown);
                        }
                    }
                    var value = unknown;
                    // handle Web Browser's change event
                    if (unknown.target && unknown.type === 'change') {
                        value = unknown.target.value;
                    }
                    // calling formask's change handler
                    _this.customChangeHandler({ id: id, value: value });
                };
                var hookBlurHandler = function (unknown) {
                    // calling props.onBlur directly
                    if (Widget.props[blurHandlerName] &&
                        typeof Widget.props[blurHandlerName] === 'function') {
                        Widget.props[blurHandlerName](unknown);
                    }
                    _this.blurHandler(id);
                };
                // If form is reseting and component is uncontrolled,
                // RESET KEY
                if (!controlled) {
                    var HookWidget = React.cloneElement(Widget, __assign({}, Widget.props, (_a = { key: id + "-" + _this.uncontrolledIndex, formaskfield: id, defaultValue: _this.props.defaultValues[id] || '' }, _a[changeHandlerName] = hookChangeHandler, _a[blurHandlerName] = hookBlurHandler, _a)));
                    switch (_this.resetType) {
                        case enum_1.resetTypeEnum.initial: {
                            HookWidget = React.cloneElement(Widget, __assign({}, Widget.props, (_b = { key: id + "-" + _this.uncontrolledIndex, formaskfield: id, defaultValue: _this.props.defaultValues[id] || '' }, _b[changeHandlerName] = hookChangeHandler, _b[blurHandlerName] = hookBlurHandler, _b)));
                            break;
                        }
                        case enum_1.resetTypeEnum.clean: {
                            HookWidget = React.cloneElement(Widget, __assign({}, Widget.props, (_c = { key: id + "-" + _this.uncontrolledIndex, formaskfield: id, defaultValue: types_1.getEmptyValueFromType(_this.state.types[id]) || '' }, _c[changeHandlerName] = hookChangeHandler, _c[blurHandlerName] = hookBlurHandler, _c)));
                            break;
                        }
                        default:
                            break;
                    }
                    return HookWidget;
                }
                return React.cloneElement(Widget, __assign({}, Widget.props, (_d = { formaskfield: id, value: Widget.props.value }, _d[changeHandlerName] = hookChangeHandler, _d[blurHandlerName] = hookBlurHandler, _d)));
            };
        };
        _this.customChangeHandler = function (option) {
            var field = option.id;
            var validateOnChange = _this.props.options.validateOnChange;
            var touches = _this.state.touches;
            var type = types_1.getType(option.value);
            warning(!!field, 'Field name is missing, giving as least name or id attributes to input');
            var touched = touches[field];
            _this.setState(function (prevState) {
                var _a, _b;
                return {
                    types: __assign({}, prevState.types, (_a = {}, _a[field] = type, _a)),
                    values: __assign({}, prevState.values, (_b = {}, _b[field] = option.value, _b))
                };
            }, (validateOnChange && touched) ?
                _this.validate.bind(_this, undefined, { onlyTouched: true }) :
                noop);
        };
        _this.changeHandler = function (e) {
            e.persist();
            var _a = e.target, id = _a.id, name = _a.name, value = _a.value;
            var validateOnChange = _this.props.options.validateOnChange;
            var touches = _this.state.touches;
            var field = name || id;
            var type = types_1.getType(value);
            warning(!!field, 'Field name is missing, giving as least name or id attributes to input');
            var touched = touches[field];
            _this.setState(function (prevState) {
                var _a, _b;
                return {
                    types: __assign({}, prevState.types, (_a = {}, _a[field] = type, _a)),
                    values: __assign({}, prevState.values, (_b = {}, _b[field] = value, _b))
                };
            }, (validateOnChange && touched) ? _this.validate.bind(_this, [field]) : noop);
        };
        // tslint:disable-next-line:no-any
        _this.blurHandler = function (unknown) {
            var _a = _this.props, _b = _a.schema, schema = _b === void 0 ? {} : _b, validateOnBlur = _a.options.validateOnBlur;
            // if unknown is an event
            if (unknown.target && unknown.type === 'blur') {
                unknown.persist();
                var _c = unknown.target, id_1 = _c.id, name_1 = _c.name;
                return _this.setState(function (prevState) {
                    var _a;
                    return {
                        touches: __assign({}, prevState.touches, (_a = {}, _a[name_1 || id_1] = true, _a))
                    };
                });
            }
            var field = utils_1.isString(unknown) && unknown;
            warning(!!field, 'Field name is missing, giving as least name or id attributes to input');
            _this.setState(function (prevState) {
                var _a;
                return {
                    touches: __assign({}, prevState.touches, (_a = {}, _a[field] = true, _a))
                };
            }, (validateOnBlur && schema[field]) ?
                _this.validate.bind(_this, undefined, { onlyTouched: true }) :
                noop);
        };
        _this.setTouches = function (newTouches) {
            if (newTouches === void 0) { newTouches = {}; }
            _this.setState(function (prevState) {
                return {
                    touches: __assign({}, prevState.touches, newTouches)
                };
            });
        };
        _this.reset = function (options) {
            if (options === void 0) { options = {}; }
            var _a = options.type, type = _a === void 0 ? 'clean' : _a, fields = options.fields;
            _this.uncontrolledIndex++;
            switch (type) {
                case 'clean': {
                    _this.resetType = enum_1.resetTypeEnum.clean;
                    if (fields) {
                        _this.setState(function (prevState) {
                            var types = prevState.types, newValues = prevState.values, newTouches = prevState.touches, newErrors = prevState.errors;
                            fields.forEach(function (field) {
                                var filedtype = types[field];
                                newValues[field] = types_1.getEmptyValueFromType(filedtype) || undefined;
                                newTouches[field] = false;
                                newErrors[field] = { valid: true };
                            });
                            return {
                                values: newValues,
                                touches: newTouches,
                                errors: proxy_1.getErrorProxy(newErrors),
                            };
                        });
                        break;
                    }
                    _this.setState(function (prevState) {
                        var types = prevState.types;
                        return {
                            isValid: true,
                            values: types_1.getCleanValueFromTypes(types),
                            touches: {},
                            errors: proxy_1.getErrorProxy({}),
                        };
                    });
                    break;
                }
                case 'initial': {
                    var _b = _this.props, _c = _b.defaultValues, defaultValues_1 = _c === void 0 ? {} : _c, _d = _b.defaultErrors, defaultErrors_1 = _d === void 0 ? {} : _d, _e = _b.defaultTouches, defaultTouches_1 = _e === void 0 ? {} : _e;
                    _this.resetType = enum_1.resetTypeEnum.initial;
                    if (fields) {
                        _this.setState(function (prevState) {
                            var newValues = prevState.values, newTouches = prevState.touches, newErrors = prevState.errors, types = prevState.types;
                            fields.forEach(function (field) {
                                var filedtype = types[field];
                                newValues[field] = defaultValues_1[field] || types_1.getEmptyValueFromType(filedtype);
                                newTouches[field] = defaultTouches_1[field];
                                newErrors[field] = defaultErrors_1[field];
                            });
                            return {
                                values: newValues,
                                touches: newTouches,
                                errors: proxy_1.getErrorProxy(newErrors),
                            };
                        });
                        break;
                    }
                    _this.setState(function (prevState) {
                        var types = prevState.types;
                        return {
                            isValid: true,
                            values: __assign({}, types_1.getCleanValueFromTypes(types), defaultValues_1),
                            touches: defaultTouches_1,
                            errors: proxy_1.getErrorProxy(defaultErrors_1),
                        };
                    });
                    break;
                }
                default:
                    break;
            }
        };
        _this.setIsSubmitting = function (isSubmitting) {
            if (isSubmitting === void 0) { isSubmitting = false; }
            _this.setState({
                isSubmitting: isSubmitting
            });
        };
        _this.submitHandler = function (e) {
            e.preventDefault();
            var _a = _this.props.onSubmit, onSubmit = _a === void 0 ? noop : _a;
            var values = _this.state.values;
            // internal form handler, validation etc..
            _this.setState(function () { return ({ isSubmitting: true }); });
            _this.validate(undefined, {
                afterValidation: function (result, isValid) {
                    onSubmit(values, Object.assign(_this.getFormaskProps(), {
                        errors: result,
                        isValid: isValid
                    }));
                }
            });
        };
        _this.validate = function (fields, options) {
            if (options === void 0) { options = {}; }
            var _a;
            var _b = _this.state, values = _b.values, touches = _b.touches;
            var _c = _this.props, _d = _c.schema, schema = _d === void 0 ? {} : _d, errorMessages = _c.errorMessages;
            var afterValidation = options.afterValidation, onlyTouched = options.onlyTouched;
            var result;
            if (fields && utils_1.isArray(fields)) {
                var valFields = onlyTouched ? fields.filter(function (field) { return touches[field]; }) : fields;
                result = (_a = kya_1.default(schema, errorMessages)).validateOn.apply(_a, [values].concat(valFields));
            }
            else {
                var valScehma = Object.assign({}, schema);
                if (onlyTouched) {
                    for (var field in valScehma) {
                        if (!touches[field]) {
                            delete valScehma[field];
                        }
                    }
                }
                result = kya_1.default(valScehma, errorMessages).validate(values);
            }
            result.then(function (re) {
                var isValid = Object.keys(re).every(function (key) {
                    return re[key].valid;
                });
                var newErrors = Object.assign({}, re);
                _this.setState({
                    errors: proxy_1.getErrorProxy(newErrors),
                    isValid: isValid
                }, function () { return afterValidation && afterValidation(newErrors, isValid); });
            });
        };
        var values = props.defaultValues || {};
        var defaultTypes = Object.keys(values).reduce(function (accu, fieldkey) {
            if (values.hasOwnProperty(fieldkey)) {
                accu[fieldkey] = types_1.getType(values[fieldkey]);
            }
            return accu;
        }, {});
        var errorsObj = __assign({}, props.defaultErrors);
        var errors = proxy_1.getErrorProxy(errorsObj);
        _this.uncontrolledIndex = 0;
        _this.resetType = enum_1.resetTypeEnum.noreset;
        _this.state = {
            values: values,
            errors: errors,
            touches: props.defaultTouches || {},
            types: defaultTypes,
            isValid: true,
            isSubmitting: false,
        };
        return _this;
    }
    Formask.prototype.componentDidMount = function () {
        // If defaultValues is specified, validator will do the first round check
        // on default values.
        var defaultValues = this.props.defaultValues;
        var fields = Object.keys(defaultValues);
        this.validate(fields);
    };
    Formask.prototype.componentDidUpdate = function (prevProps) {
        if (!equal_1.objectDeepEqual(prevProps.schema, this.props.schema)) {
            this.validate(undefined, { onlyTouched: true });
            return;
        }
    };
    Formask.prototype.render = function () {
        var _a = this.props, render = _a.render, children = _a.children;
        var injectedProps = this.getFormaskProps();
        return render ?
            render(injectedProps) :
            children ?
                typeof children === 'function' ?
                    children(injectedProps) :
                    React.Children.count(children) !== 0 ?
                        React.Children.only(children) :
                        null
                : null;
    };
    Formask.propTypes = {
        defaultValues: PropTypes.object,
        defaultErrors: PropTypes.object,
        defaultTouches: PropTypes.object,
        validator: PropTypes.func,
        render: PropTypes.func,
        children: PropTypes.any,
        options: PropTypes.object,
    };
    Formask.defaultProps = {
        schema: {},
        defaultErrors: {},
        defaultValues: {},
        options: {
            validateOnBlur: true,
            validateOnChange: true
        },
    };
    return Formask;
}(React.Component));
exports.default = Formask;



// WEBPACK FOOTER //
// ./src/dist/commonjs/formask.js